/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Missing_Speaker_LabelInputs */

const en_style_guide_manager_missing_speaker_label = /** @type {(inputs: Style_Guide_Manager_Missing_Speaker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing Speaker Assignment`)
};

const fr_style_guide_manager_missing_speaker_label = /** @type {(inputs: Style_Guide_Manager_Missing_Speaker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affectation de locuteur manquante`)
};

const de_style_guide_manager_missing_speaker_label = /** @type {(inputs: Style_Guide_Manager_Missing_Speaker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlende Sprecherzuweisung`)
};

const it_style_guide_manager_missing_speaker_label = /** @type {(inputs: Style_Guide_Manager_Missing_Speaker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assegnazione dell'oratore mancante`)
};

const ru_style_guide_manager_missing_speaker_label = /** @type {(inputs: Style_Guide_Manager_Missing_Speaker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отсутствует назначение спикера`)
};

const es_style_guide_manager_missing_speaker_label = /** @type {(inputs: Style_Guide_Manager_Missing_Speaker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignación de orador faltante`)
};

const zh_cn2_style_guide_manager_missing_speaker_label = /** @type {(inputs: Style_Guide_Manager_Missing_Speaker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缺少发言人分配`)
};

const ja_style_guide_manager_missing_speaker_label = /** @type {(inputs: Style_Guide_Manager_Missing_Speaker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーの割り当てが不明`)
};

const hi_style_guide_manager_missing_speaker_label = /** @type {(inputs: Style_Guide_Manager_Missing_Speaker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ता का असाइनमेंट गायब है`)
};

const pt_pt2_style_guide_manager_missing_speaker_label = /** @type {(inputs: Style_Guide_Manager_Missing_Speaker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atribuição de palestrante ausente`)
};

/**
* | output |
* | --- |
* | "Missing Speaker Assignment" |
*
* @param {Style_Guide_Manager_Missing_Speaker_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_missing_speaker_label = /** @type {((inputs?: Style_Guide_Manager_Missing_Speaker_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Missing_Speaker_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_missing_speaker_label(inputs)
	if (locale === "de") return de_style_guide_manager_missing_speaker_label(inputs)
	if (locale === "it") return it_style_guide_manager_missing_speaker_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_missing_speaker_label(inputs)
	if (locale === "es") return es_style_guide_manager_missing_speaker_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_missing_speaker_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_missing_speaker_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_missing_speaker_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_missing_speaker_label(inputs)
	return en_style_guide_manager_missing_speaker_label(inputs)
});